export default __webpack_public_path__ + "static/PromptIconSix-4a4c205fcbb4967c40fd6b563d2d3f35.png";